<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Accounting</div><h2>Vendors</h2></div>
            <div>
                <el-button size="small" type="primary" @click="syncFromBuildium">Sync from Buildium</el-button>
            </div>
        </div>
        <section class="page-section">
            <el-form :inline="true" size="medium">
                <el-form-item label="Name">
                    <el-input size="medium" class="w200" :clearable="true" v-model="params.name"/>
                </el-form-item>
                <el-form-item label="Email">
                    <el-input size="medium" class="w200" :clearable="true" v-model="params.email"/>
                </el-form-item>
                <el-form-item label="Phone">
                    <el-input size="medium" class="w200" :clearable="true" v-model="params.phone"/>
                </el-form-item>
                <el-form-item label="Status">
                    <el-select size="medium" v-model="params.status" placeholder="Status" clearable>
                        <el-option label="Active" value="Active"/>
                        <el-option label="Inactive" value="Inactive"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="Paid Date">
                    <el-date-picker
                        v-model="params.daterange"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="From"
                        end-placeholder="To"
                        value-format="yyyy-MM-dd"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="onSearch">Search</el-button>
                </el-form-item>
            </el-form>
        </section>
        <section class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column prop="Id" label="ID" width="100"/>
                <el-table-column prop="name" label="Name"/>
                <el-table-column prop="PrimaryEmail" label="Email"/>
                <el-table-column prop="AlternateEmail" label="Alternate Email"/>
                <el-table-column label="PhoneNumber" width="160">
                    <template slot-scope="scope">
                        <div v-for="phone in scope.row.PhoneNumbers||[]">{{ phone.Number }}</div>
                    </template>
                </el-table-column>
                <el-table-column label="Actions" align="right" width="200">
                    <template slot-scope="scope">
                        <a class="el-link el-link--primary" @click="$refs.vendorTransactions.open(scope.row.Id)">Transactions</a>
                    </template>
                </el-table-column>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-button type="primary" size="small" @click="batchDelete">{{
                            $t('common.batch_delete')
                        }}
                    </el-button>
                </div>
                <div class="flex"></div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>
        <modal-vendor-transactions ref="vendorTransactions"/>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import ApiService from "../utils/ApiService";
import ModalVendorTransactions from "./ModalVendorTransactions.vue";

export default {
    name: "Vendors",
    components: {ModalVendorTransactions},
    mixins: [Pagination],
    data() {
        return {
            bulkAction: '',
            autoSearch: true,
            params: {
                name: '',
                email: '',
                phone: '',
                status: 'Active',
                daterange: []
            },
            pageSize: 20
        }
    },
    methods: {
        listApi() {
            return '/buildium/vendors'
        },
        listParams() {
            return this.params;
        },
        syncFromBuildium() {
            const loading = this.$loading({
                lock: true,
                text: 'Synchronizing...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$api.get('/buildium/vendors/sync').then(response => {
                this.$message.success('Sync completed');
                this.fetchList();
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                loading.close();
            });
        },
        batchDelete() {
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                this.loading = true;
                let ids = this.selectionIds.map((d) => d.Id);
                ApiService.delete('/buildium/vendors/batch', {data: {ids}}).then(() => {
                    this.fetchList();
                    this.$message.success('Vendors Deleted');
                }).catch(reason => {
                    this.$message.error(reason.message);
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        getFullName(vendor) {
            return (vendor?.FirstName || '') + ' ' + (vendor?.LastName || '');
        },
        onBulkAction() {
            switch (this.bulkAction) {
                case 'delete':
                    this.batchDelete();
                    break;
            }
        }
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<style scoped>

</style>